// extracted by mini-css-extract-plugin
export default {"previews":"tXEF6","landscape":"vlOIU","portrait":"k4Oj9","link":"XGLam","content":"GtlTm","gallery":"L9GTY","item":"YwuZq","image":"F15NT"};